module.exports = function(num){
    if (!isNaN(num)){
        return num.toString(10)+'px';
    }
    return num;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/add-px/index.js
// module id = 517
// module chunks = 0